import axios from "axios"
// axios.defaults.withCredentials = true;//让ajax携带cookie
// 引入进度条
// import nprogress from 'nprogress'
//  引入进度条的样式
// import 'nprogress/nprogress.css'
// 引入路由
import router from '../router'
class Request {
  // 自定义变量
  instance;
  constructor(config) {
    // 创建axios 实例，变量接收
    this.instance = axios.create(config);
    // 添加请求拦截器
    this.instance.interceptors.request.use(
      (config) => {
        if(localStorage.getItem("user_token")){
          config.headers.Authorization  = `Bearer ${localStorage.getItem("user_token")}`
        }
        return config;
      },
      (error) => {
        
        return error;
      }
    );
    // 添加相应拦截器
    this.instance.interceptors.response.use(
      (res) => {
        // nprogress.done()
        if (res.data.status == '1') {
          // Message({
          //   message: res.data.msg,
          //   type: 'success',
          // })
          return res.data
        } else if (res.data.status === -1) {
          // Message({
          //   message: res.data.msg,
          //   type: 'error',
          // })
          localStorage.clear()
          sessionStorage.clear()
          router.push("/")
          return res.data
        } else { 
          // Message({
          //   message: res.data.msg,
          //   type: 'error',
          // })
          return res.data
        }
      },
      (error) => {
        return error;
      }
    );
  }
  // 2
  request(config) {
    return new Promise((resolve, reject) => {
      this.instance.request(config).then((res) => {
        return resolve(res);
      }).catch((error) => {
        return reject(error);
      });
    });
  }
  // 1
  get(config) {
    return this.request({
      ...config,
      method: "GET",
    });
  }
  post(config) {
    const formData = new FormData()
    for (const key in config.params) {
      formData.append(key, config.params[key])
    }
    return this.request({
      data: formData,
      url: config.url,
      method: "POST",
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  postjson(config) {
    return this.request({
      ...config,
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  patch(config) {
    return this.request({
      ...config,
      method: "PATCH",
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  put(config) {
    return this.request({
      ...config,
      method: "PUT",
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  delete(config) {
    return this.request({
      ...config,
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

export default Request;
